import styled from 'styled-components'

const SwipeSectionStyle = styled.div`
	--swipeImageHeight: 50%;
	--handleWidth: var(--sp2x);

	margin-top: var(--bannerDistance);

	.imageCont {
		--proportion: var(--swipeImageHeight);
		z-index: 0;
	}

	.handle {
		width: var(--handleWidth);
		height: 100%;
		background: var(--gray99);
		z-index: 99;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeL}) {
		/* --swipeImageHeight: 50%; */
		--handleWidth: var(--sp1x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeM}) {
		/* --swipeImageHeight: 50%; */
		--handleWidth: var(--sp1x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeS}) {
		/* --swipeImageHeight: 50%; */
		--handleWidth: var(--sp1x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeXS}) {
		/* --swipeImageHeight: 50%; */
		--handleWidth: var(--sp1x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSize}) {
		/* --swipeImageHeight: 50%; */
		--handleWidth: var(--sp1x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSizeS}) {
		/* --swipeImageHeight: 50%; */
		--handleWidth: var(--sp1x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		/* --swipeImageHeight: 50%; */
		--handleWidth: var(--sp1x);
	}
`

export default SwipeSectionStyle
